import React, {useContext} from 'react';
import {View} from 'react-native';
import {shopContext} from '../../../contexts/ShopContext';
import {removeSpaceAndCaptalize, tID} from '../../../utils/TestIdHelper';
import DashedDivider from '../../elements/DashedDivider';

import Text from '../../elements/Text';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';

export const OverviewRow = ({title, value}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View style={styles.rowContainer}>
      <Text
        testID={tID(`CartPriceOverview-Text-${removeSpaceAndCaptalize(title)}`)}
        variation="Text1Regular"
        color={colors.textDisabled}
        maxFontSizeMultiplier={2}
        style={styles.rowLabel}>
        {title}
      </Text>
      <Text
        testID={tID(`CartPriceOverview-Text-${removeSpaceAndCaptalize(value)}`)}
        variation="Text1Regular"
        color={colors.textPrimary}
        maxFontSizeMultiplier={2}
        style={[styles.ls2, styles.rowValue]}>
        {value}
      </Text>
    </View>
  );
};

const CartPriceOverview = ({sectionTitle, instruction}) => {
  const ShopC = useContext(shopContext);
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);

  let total = 0;

  ShopC?.cartProducts.forEach(e => {
    total = total + parseInt(e.productQty) * parseFloat(e.price);
  });
  // Supplies ship FREE and nothing is ever charged in the app — no shipping
  // fee, no tax. Do NOT reinstate the old "$4 shipping under $25" rule (it
  // predates the free model; see Checkout's order params for the same rule).
  const grandTotal = total;

  return (
    <View
      testID={tID('CartPriceOverview-View-Container')}
      style={styles.container}>
      {sectionTitle && (
        <Text
          testID={tID('CartPriceOverview-Text-SectionTitle')}
          variation="Subtitle1Bold"
          color={colors.link}
          style={styles.mb16}>
          {sectionTitle}
        </Text>
      )}
      <View
        testID={tID('CartPriceOverview-View-PriceDetailContainer')}
        style={styles.priceDetailContainer}>
        <OverviewRow title="Items" value={'$ ' + total.toFixed(2)} />
        <OverviewRow title="Shipping & Handling" value="Free" />
        <View style={styles.marginVertical16}>
          <DashedDivider color={colors.border} dashWidth={5} space={5} />
        </View>
        <View style={styles.totalContainer}>
          <Text
            variation="Body1SemiBold"
            color={colors.textPrimary}
            maxFontSizeMultiplier={2}
            style={styles.rowLabel}>
            Total Price
          </Text>
          <Text
            testID={tID('CartPriceOverview-Text-GrandTotal')}
            variation="Body1SemiBold"
            color={colors.link}
            maxFontSizeMultiplier={2}
            style={styles.rowValue}>
            $ {grandTotal.toFixed(2)}*
          </Text>
        </View>
      </View>
      {instruction && (
        <Text
          testID={tID('CartPriceOverview-Text-Instruction')}
          variation="Text1Regular"
          color={colors.textMuted}
          topMargin={16}>
          {instruction}
        </Text>
      )}
    </View>
  );
};

export default CartPriceOverview;
